import { getTenantConfig, TENANTS } from 'src/config/tenant'
import { getOverrideTenantKey } from 'src/new-components/forms/app-config/state'

const useProxy = process.env.REACT_APP_USE_PROXY === 'true'

const tenantConfig = TENANTS[getOverrideTenantKey() ?? ''] ?? getTenantConfig()

// Legacy GraphQL API URL (with dev override support)
export const baseUrl = useProxy
  ? '' // Local dev with Vite proxy
  : tenantConfig.graphqlUrl

// Microservices API URL
export const servicesBaseUrl = useProxy
  ? '/api' // Local dev with Vite proxy
  : tenantConfig.servicesUrl
